import TaskView from "./TaskView"
import Button from "./Button"
import CreateTaskForm from "./CreateTaskForm"
import Popup from "./Popup";
import React, { useState } from "react";
import './styles/Main.css';

const Main = ({user, setUser}) => {
    // Add Task Form and control state.
    const [showCreate, setShowCreate] = useState(false)
    const toggleCreateForm = () => {setShowCreate(!showCreate)}

    // Create Task Method - Passed to the CreateTaskForm component.
    const createTask = async (taskName) => {
        // Create date stamp - verify data date.
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        if (dateStamp !== user.lastLogin) {
            alert('Session Expired. Please sign in again.')
            setUser(null)
            return
        }
        const res = await fetch('https://GradientBack.3-sigma.repl.co/task', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({sessionToken: user.sessionToken, name: taskName, username: user.name})
        })
        if (res.status === 201) {
            const data = await res.json()
            user.tasks["notStarted"].push(data)
            setUser({...user})
        }
        else if (res.status === 401) {
            alert('Session Expired. Signed in on another device.')
            setUser(null)
        }
        else {
            alert('Something went wrong while creating the task. Please Try Again.')
        }
        toggleCreateForm()
    }

    // Subcomponents for Add Task Popup.
    const createTaskForm = <CreateTaskForm createTask={createTask}/>
    const addTaskButton = 
        <Button color='lightgreen' text='Add Task' onClick={toggleCreateForm}/>
    const addTaskPopup = <Popup dismiss={toggleCreateForm} content={createTaskForm}/>

    return (
        <div className = "main">
            {showCreate ? addTaskPopup : addTaskButton}
            <TaskView user={user} setUser={setUser}/>
            <Button color='black' text='Logout' onClick = {() => setUser(null)}/>
        </div>
    )
}

export default Main
